var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductCarouselArrowNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.615071615
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop/Home-New-User-Prospect-2",
    transform: "translate(-1259.000000, -2594.000000)",
    fill: "#CFF3FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Better-Module",
    transform: "translate(-290.000000, 2252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Right",
    transform: "translate(1589.000000, 382.000000) rotate(90.000000) translate(-1589.000000, -382.000000) translate(1549.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C17.9100654,0 0,17.907451 0,40 C0,62.092549 17.9100654,80 40,80 C62.092549,80 80,62.0899346 80,40 C80,17.9100654 62.092549,0 40,0 Z M56.4085029,41.3751492 C55.4268698,42.3607961 53.8377217,42.3607961 52.8585827,41.3751492 L42.5102168,30.988494 L42.5102168,57.6700192 C42.5102168,59.0613114 41.3855,60.1904762 39.9996882,60.1904762 C38.6138765,60.1904762 37.4891597,59.0613114 37.4891597,57.6700192 L37.4891597,30.988494 L27.1432879,41.3751492 C26.1616548,42.3607961 24.5725066,42.3607961 23.5933677,41.3751492 C22.6117346,40.389634 22.6117346,38.794333 23.5933677,37.8113218 L37.7954113,23.5531129 C38.3954441,22.9507072 39.2213916,22.7617223 39.9996882,22.9003639 C40.7779849,22.7617223 41.6039324,22.9507072 42.2064593,23.5531129 L56.4085029,37.8113218 C57.3876419,38.7968369 57.3876419,40.3922698 56.4085029,41.3751492 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCarouselArrowNext);
export default __webpack_public_path__ + "static/media/product-carousel-arrow-next.7d09890781f7655867a21a51327e77ae.svg";
export { ForwardRef as ReactComponent };